<script lang="ts">
	//Hooks
	import { createEventDispatcher, setContext } from 'svelte';
	//Components
	import WizzardWrapper from '../../../../components/ModalWizzard/WizzardWrapper.svelte';
	import TimeWrapper from '../NightModeStepComponents/TimeWrapper.svelte';
	import BrightnessWrapper from '../NightModeStepComponents/BrightnessWrapper.svelte';
	import ModeWrapper from '../NightModeStepComponents/ModeWrapper.svelte';
	import ColorWrapper from '../NightModeStepComponents/ColorWrapper.svelte';
	import WhiteWrapper from '../NightModeStepComponents/WhiteWrapper.svelte';
	import ColorTempWrapper from '../NightModeStepComponents/ColorTempWrapper.svelte';
	//Services
	import { format } from '../../../../services/i18n';
	import { writable } from 'svelte/store';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { Device } from 'src/types/Device';

	export let props, showModal, device: Device;
	export let deviceType: string | undefined;

	const dispatcher = createEventDispatcher();
	let time = [props.start, props.end];
	let brightness = props.brightness;
	let mode = props.hasOwnProperty('mode') && typeof props.mode !== 'undefined' ? props.mode : null;
	let rgb = props.hasOwnProperty('rgb') && typeof props.rgb !== 'undefined' ? props.rgb : undefined;
	let white =
		props.hasOwnProperty('white') && typeof props.white !== 'undefined' ? props.white : undefined;
	let ct = props.hasOwnProperty('ct') && typeof props.ct !== 'undefined' ? props.ct : undefined;
	let valueRange = props.valueRange;
	let min = props.min;

	const handleSave = async () => {
		dispatcher('save', props);
	};

	const createNightModeStore = () => {
		const { subscribe, update } = writable({
			time,
			brightness,
			mode,
			rgb,
			white,
			ct,
			valueRange,
			min,
			deviceType,
		});
		return {
			subscribe,
			change: (newData) =>
				update((oldData) => {
					oldData = { ...oldData, ...newData };
					return oldData;
				}),
		};
	};

	const nightModeStore = createNightModeStore();
	setContext('nightMode', nightModeStore);

	const wizardItems = [
		{
			active: true,
			activeIndex: 0,
			disabled: false,
			showMoreDots: false,
			stepNumber: 1,
			title: capFirstChar($format('title_time', { default: 'Time' })),
			tooltipTitle: '',
			component: TimeWrapper,
		},
		{
			active: false,
			activeIndex: 1,
			disabled: false,
			showMoreDots: false,
			stepNumber: 2,
			title: capFirstChar($format('label_brightness', { default: 'Brightness' })),
			tooltipTitle: '',
			component: BrightnessWrapper,
		},
	];

	// Exclude mode step for S3BL-D010009AEU
	if (deviceType !== 'S3BL-D010009AEU') {
		wizardItems.push({
			active: false,
			activeIndex: 2,
			disabled: false,
			showMoreDots: false,
			stepNumber: 3,
			title: capFirstChar($format('label_mode', { default: 'Mode' })),
			tooltipTitle: '',
			component: ModeWrapper,
		});
	}

	if (typeof rgb !== 'undefined') {
		wizardItems.push({
			active: false,
			activeIndex: wizardItems.length,
			disabled: false,
			showMoreDots: false,
			stepNumber: wizardItems.length + 1,
			title: capFirstChar($format('title_color', { default: 'Color' })),
			tooltipTitle: '',
			component: ColorWrapper,
		});
	}

	if (typeof white !== 'undefined') {
		wizardItems.push({
			active: false,
			activeIndex: wizardItems.length,
			disabled: false,
			showMoreDots: false,
			stepNumber: wizardItems.length + 1,
			title: capFirstChar($format('title_white', { default: 'White' })),
			tooltipTitle: '',
			component: WhiteWrapper,
		});
	}

	if (typeof ct !== 'undefined') {
		wizardItems.push({
			active: false,
			activeIndex: wizardItems.length,
			disabled: false,
			showMoreDots: false,
			stepNumber: wizardItems.length + 1,
			title: capFirstChar($format('title_color_temp', { default: 'Color Temperature' })),
			tooltipTitle: '',
			component: ColorTempWrapper,
		});
	}

	const updateStore = (e) => {
		nightModeStore.change(e.detail);
		let _time = $nightModeStore.time;
		props.start = _time[0];
		props.end = _time[1];
		props.brightness = $nightModeStore.brightness;
		props.mode = $nightModeStore.mode;
		props.rgb = $nightModeStore.rgb;
		props.white = $nightModeStore.white;
		props.ct = $nightModeStore.ct;
	};
</script>

<WizzardWrapper
	bind:showModal
	title={$format('settings_title_night_mode')}
	{wizardItems}
	callback={handleSave}
	on:updateStore={updateStore}
/>
